export const EMAIL_REGEXP = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
export const NAME_REGEXP = /^[а-яА-ЯёЁ]+(?:[ '-][а-яА-ЯёЁ]+)*$/;
export const PHONE_REGEXP = /\+7 *\(?[0-9]{3}\)? *[0-9]{3}(-| )*[0-9]{2}(-| )*[0-9]{2}/;
export const DATE_FORMAT = 'dd.MM.yyyy';
